import './styles/NavigationButtonStyle.css';

interface NavigationButtonProps {
  onClickButton(): void;
  buttonContent: any;
  buttonClass: string;
  dataCy?: string;
  disabled?: boolean;
}
const NavigationButton: React.FC<NavigationButtonProps> = ({
  onClickButton,
  buttonContent,
  buttonClass,
  dataCy,
  disabled,
}) => {
  return (
    <button
      disabled={disabled}
      onClick={() => onClickButton()}
      className={`navigation-button ${buttonClass} ${
        disabled ? 'disabled' : 'stepOn'
      }`}
      data-cy={dataCy ? dataCy : ''}
    >
      {buttonContent}
    </button>
  );
};

export { NavigationButton };
